import React from 'react';
import { RouteTemplate } from '../types';

interface Props {
  templates: RouteTemplate[];
  onApply: (template: RouteTemplate) => void;
}

/**
 * Ustaljeni pravci razvoza.
 *
 * Šablon je polazna tačka, ne pravilo — kad se učita, stanice se i dalje mogu
 * dodavati, izbacivati i preređivati. Zato dugme kaže „učitaj", ne „primeni".
 */
export default function TemplatePicker({ templates, onApply }: Props) {
  if (templates.length === 0) {
    return null;
  }

  const today = templates.filter((t) => t.appliesToday);
  const others = templates.filter((t) => !t.appliesToday);

  return (
    <div className="templates">
      {today.length > 0 ? (
        <>
          <p className="templates__title">Pravci za danas</p>
          <div className="templates__row">
            {today.map((t) => (
              <TemplateButton key={t.id} template={t} onApply={onApply} highlight />
            ))}
          </div>
        </>
      ) : (
        <p className="templates__title">Danas nema ustaljenog pravca.</p>
      )}

      {others.length > 0 && (
        <details className="details">
          <summary>Ostali pravci ({others.length})</summary>
          <div className="templates__row">
            {others.map((t) => (
              <TemplateButton key={t.id} template={t} onApply={onApply} />
            ))}
          </div>
        </details>
      )}
    </div>
  );
}

function TemplateButton({
  template, onApply, highlight
}: { template: RouteTemplate; onApply: (t: RouteTemplate) => void; highlight?: boolean }) {
  const route = template.stops.map((s) => s.destination).join(' → ');

  return (
    <button
      type="button"
      className={`template ${highlight ? 'template--today' : ''}`}
      onClick={() => onApply(template)}
      title={`Učitaj: ${route}`}
    >
      <span className="template__name">{template.name}</span>
      <span className="template__days">{template.days}</span>
    </button>
  );
}
